<template>
  <div class="comments-input-area">
    <div class="comments-input">
        <textarea name="comments-area" id="comments-area" cols="20" rows="10" class="default-textarea" v-model="comment"></textarea>
        <label for="comments-area" class="blind">내용</label>
    </div>
    <div class="comments-btn">
        <button type="button" class="default-btn" @click="addComment(comment, postIdUser, 'user', postUserStatus)" v-if="postIdUser > 0">등록</button>
        <button type="button" class="default-btn" @click="addComment(comment, postIdAdmin, 'admin', postAdminStatus)" v-if="postIdAdmin > 0">등록</button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../css/admin.scss';
@import '../css/sub.scss';
</style>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CommentsInput',

  data () {
    return {
      comment: ''
    }
  },
  methods: {
    addComment (content, postId, rule, status) {
      if (this.adminInitStatus === 'COMPLETED') {
        alert('완료된 제보는 코멘트를 등록할 수 없습니다.')
        return false
      }
      if (content) {
        const param = {
          'content': content.split('\n').join('<br>'),
          postId: postId
        }
        if (confirm('등록하시겠습니까?')) {
          if (rule === 'user') {
            this.$store.dispatch('apiInformantPostsComment', param)
          } else if (rule === 'admin') {
            this.$store.dispatch('apiAdminPostsComment', param)
          } else {
            return
          }
          this.comment = ''
        } else {
          return false
        }
      } else {
        alert('내용을 입력해주세요.')
      }
    }
  },
  computed: {
    ...mapGetters({
      postIdUser: 'getPostIdUser',
      postIdAdmin: 'getPostIdAdmin',
      postAdminStatus: 'getAdminPostStatus',
      postUserStatus: 'getUserPostStatus',
      adminInitStatus: 'getAdminInitStatus'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommentsInput.vue